import { useQuery } from "react-query";
import { useFetchAllData } from "src/shared/lib/hooks/context";
import { apiRequests } from "src/shared/api/api";

export const useFetchGetContragents = (options) => {
  const { token, name, } = options;
  const query = useQuery(
    ["contragents", token, name],
    async () => {
      const response = await apiRequests.contragents.getItems({ token, name });
      return response.data.result;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  return query;
};

export const useFetchAllContragents = ({ token }) =>
  useFetchAllData({ token, key: "contragents", path: "contragents/" });
